export const SURVEY_STATUS = {
    'In Progress': {
        en: 'In Progress',
        es: 'En progreso'
    },
    Pending: {
        en: 'Pending',
        es: 'Pendiente'
    },
    Submitted: {
        en: 'Submitted',
        es: 'Enviada'
    },
    Upcoming: {
        en: 'Upcoming',
        es: 'Próxima'
    },
    Accepted: {
        en: 'Accepted',
        es: 'Aceptada'
    },
    Rejected: {
        en: 'Rejected',
        es: 'Rechazada'
    }
} as Record<string, { en: string; es: string }>;
